"use client";
import { MenuItem } from "@/lib/types";
import AnimatedHamburger from "./AnimatedHamburger";
import NavigationOverlay from "./NavigationOverlay";

interface MobileNavProps {
  menuItems: MenuItem[];
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
}

const MobileNav = ({
  menuItems,
  isOpen,
  onToggle,
  onClose,
}: MobileNavProps) => {
  return (
    <div className="lg:hidden">
      {/* ===== Hamburger / Close button ===== */}
      {!isOpen && (
        <AnimatedHamburger
          isOpen={isOpen}
          onClick={onToggle}
          color="#b2d127"
          openColor="#fff"
          size={24}
          lineHeight={2}
        />
      )}

      {/* ===== Full-Screen Overlay Menu ===== */}

      <NavigationOverlay
        menuItems={menuItems}
        isOpen={isOpen}
        onClose={onClose}
        // Specific start point for mobile corner
        revealPoint="circle(0% at calc(100% - 40px) 28px)"
      />
    </div>
  );
};

export default MobileNav;
